import React, { useEffect } from 'react';
import './NotificationBanner.css';

interface NotificationBannerProps {
  message: string;
  onLinkClick?: () => void; // optional link for CTA; hidden if not provided
  onClose: () => void;
  variant?: 'error' | 'info' | 'warning'; // reserved for future use; error remains orange (#FF3100)
  linkLabel?: string; // defaults to "here"
}

const NotificationBanner: React.FC<NotificationBannerProps> = ({ message, onLinkClick, onClose, variant = 'error', linkLabel = 'here' }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 6000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`notification-banner ${variant}`}>
      <span>{message} </span>
      {onLinkClick && (
        <button className="notification-link" onClick={onLinkClick}>
          {linkLabel}
        </button>
      )}
    </div>
  );
};

export default NotificationBanner;
